<template>
	<div class="navbar pr-0 hide">
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alertSideBar" type="alert" @remove="removeAlert"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>

		<i-modal ref="modalSetPin" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3" v-if="pin_success == false">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-12 pt-3 font-size-10 text-center">
                            Silahkan set PIN Mobile Counter Anda
                        </div>
						<div class="col-12 pt-3">
                            <input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="PIN" v-model="pin_code" :maxlength="pin_max_length">
							<div class="font-size-8 pt-1">PIN 6 digit angka [{{ pin_code.length}} / {{ pin_max_length }}]</div>
                            <div class="invalid-feedback d-block m-0" v-if="konfirmResponse.msg">{{ konfirmResponse.msg }} </div>
                        </div>
					</div>
				</div>
				<div class="modal-body pt-0 pt-md-3" v-if="pin_success == true">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-12 pt-3 font-size-10 text-center">
                            PIN berhasil disimpan. Anda dapat melakukan perubahan PIN pada Menu Pengaturan > Pengaturan PIN
                        </div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div class="modal-footer justify-content-center justify-content-center" v-if="pin_success == false">
						<button class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="submitPin">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Ok</div>
						</button>
					</div>
					<div class="modal-footer justify-content-center justify-content-center" v-if="pin_success == true">
						<button class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="hideModalPin">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Tutup</div>
						</button>
					</div>
				</div>
			</template>
		</i-modal>
		<ul class="navbar-nav">
			<li class="item-start">
				<router-link :to="{ name: 'dashboard' }">
					<img src="/assets/sidebar/logo-milagros.png" @click="hideNav">
				</router-link>
				<img src="/assets/sidebar/icon-menu-minimize.svg">
			</li>
			<div id="accordionSidebar" v-if="userData">
				<router-link :to="{ name: 'dashboard' }" class="text-deco">
					<li class="item" @click="hideNav">
						<span class="icon"><i class="fas fa-home"></i></span>
						<span class="nav-link">Dashboard</span>
					</li>
				</router-link>
				<li class="item cursor-pointer" id="accordionSales" data-toggle="collapse" data-target="#collapseInventory" v-if="(userData.stockist_menu && userData.stockist_menu.includes('stock-history')) || (userData.stockist_menu && userData.stockist_menu.includes('stock-serial')) || userData.stockist_type== 'utama'">
					<span class="icon"><i class="fas fa-boxes"></i></span>
					<span class="nav-link">Stok</span>
					<span class="icon pr-0 d-flex justify-content-end"><i class="fas fa-angle-down"></i></span>
				</li>
				<li class="collapse" id="collapseInventory" data-parent="#accordionSidebar">
					<router-link :to="{ name: 'stock-serial' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('stock-serial')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-box-open"></i></span>
							<span class="nav-link">Stok Serial</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'stock-history' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('stock-history')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-scroll"></i></span>
							<span class="nav-link">Riwayat Stok</span>
						</div>
					</router-link>
          <router-link :to="{ name: 'stock-serial-convert' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('stock-serial-convert')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-scroll"></i></span>
							<span class="nav-link">Konversi Serial</span>
						</div>
					</router-link>

					<router-link :to="{ name: 'stock-serial-digital' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('stock-serial-digital')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-box-open"></i></span>
							<span class="nav-link">Stok Serial Digital</span>
						</div>
					</router-link>
				</li>
				<router-link :to="{ name: 'transaction' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('transaction'))|| userData.stockist_type== 'utama'">
					<li class="item" @click="hideNav">
						<span class="icon"><i class="fas fa-shopping-cart"></i></span>
						<span class="nav-link">Transaksi</span>
					</li>
				</router-link>
				<!-- <router-link :to="{ name: 'register' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('register')) || userData.stockist_type== 'utama'">
					<li class="item" @click="hideNav">
						<span class="icon"><i class="fas fa-user-plus"></i></span>
						<span class="nav-link">Registrasi</span>
					</li>
				</router-link> -->
				<li class="item cursor-pointer" id="accordionReport" data-toggle="collapse" data-target="#collapseReport" v-if="(userData.stockist_menu && userData.stockist_menu.includes('sales-report')) || (userData.stockist_menu && userData.stockist_menu.includes('new-mitra-report')) || userData.stockist_type== 'utama'">
					<span class="icon"><i class="fas fa-chart-bar"></i></span>
					<span class="nav-link">Laporan</span>
					<span class="icon pr-0 d-flex justify-content-end"><i class="fas fa-angle-down"></i></span>
				</li>
				<li class="collapse" id="collapseReport" data-parent="#accordionSidebar">
					<router-link :to="{ name: 'sales-report' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('sales-report')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-chart-area"></i></span>
							<span class="nav-link">Laporan Penjualan</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'sales-report-new' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('sales-report-new')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-chart-area"></i></span>
							<span class="nav-link">Laporan Penjualan (New)</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'new-mitra-report' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('new-mitra-report')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-chart-line"></i></span>
							<span class="nav-link">Laporan Mitra Baru</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'sales-analysis' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('sales-analysis')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-chart-area"></i></span>
							<span class="nav-link">Analisa Penjualan</span>
						</div>
					</router-link>
				</li>
				
				<!-- PO -->

				<!-- <li class="item cursor-pointer" id="accordionPO" data-toggle="collapse" data-target="#collapsePO" v-if="(userData.stockist_menu && userData.stockist_menu.includes('purchase-order-list')) || (userData.stockist_menu && userData.stockist_menu.includes('purchase-order')) || userData.stockist_type== 'utama'">
					<span class="icon"><i class="fas fa-shopping-bag"></i></span>
					<span class="nav-link">Belanja Produk</span>
					<span class="icon pr-0 d-flex justify-content-end"><i class="fas fa-angle-down"></i></span>
				</li>
				<li class="collapse" id="collapsePO" data-parent="#accordionSidebar">
					<router-link :to="{ name: 'purchase-order' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('purchase-order')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-plus-circle"></i></span>
							<span class="nav-link">Belanja Produk</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'purchase-order-list' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('purchase-order-list')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-list"></i></span>
							<span class="nav-link">Riwayat Belanja Produk</span>
						</div>
					</router-link>
				</li> -->

				<router-link :to="{ name: 'purchase-order' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('purchase-order'))|| userData.stockist_type== 'utama'">
					<li class="item" @click="hideNav">
						<span class="icon"><i class="fas fa-shopping-bag"></i></span>
						<span class="nav-link">Belanja Produk</span>
					</li>
				</router-link>

				<!-- PO -->

				<router-link :to="{ name: 'receipt' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('receipt')) || userData.stockist_type== 'utama'">
					<li class="item" @click="hideNav">
						<span class="icon"><i class="fas fa-qrcode"></i></span>
						<span class="nav-link">Pesanan Saya</span>
					</li>
				</router-link>
				<!-- <li class="item cursor-pointer" id="accordionSerial" data-toggle="collapse" data-target="#collapseSerial" v-if="(userData.stockist_menu && userData.stockist_menu.includes('serial')) || (userData.stockist_menu && userData.stockist_menu.includes('profile')) || userData.stockist_type== 'utama'">
					<span class="icon"><i class="fas fa-exchange-alt"></i></span>
					<span class="nav-link">Penukaran Serial</span>
					<span class="icon pr-0 d-flex justify-content-end"><i class="fas fa-angle-down"></i></span>
				</li>
				<li class="collapse" id="collapseSerial" data-parent="#accordionSidebar">
					<router-link :to="{ name: 'convert-serial' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('convert-serial')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-exchange-alt"></i></span>
							<span class="nav-link">Penukaran Serial</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'data-convert-serial' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('data-convert-serial')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-list"></i></span>
							<span class="nav-link">Data Penukaran Serial</span>
						</div>
					</router-link>
				</li> -->
				<li class="item cursor-pointer" id="accordionSetting" data-toggle="collapse" data-target="#collapseSetting" v-if="(userData.stockist_menu && userData.stockist_menu.includes('setting-edc')) || (userData.stockist_menu && userData.stockist_menu.includes('profile')) || userData.stockist_type== 'utama'">
					<span class="icon"><i class="fas fa-cog"></i></span>
					<span class="nav-link">Pengaturan</span>
					<span class="icon pr-0 d-flex justify-content-end"><i class="fas fa-angle-down"></i></span>
				</li>
				<li class="collapse" id="collapseSetting" data-parent="#accordionSidebar">
					<router-link :to="{ name: 'profile' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('profile')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-user-cog"></i></span>
							<span class="nav-link">Menu Profile</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'setting-edc' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('setting-edc')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-cogs"></i></span>
							<span class="nav-link">Pembayaran EDC</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'setting-address' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('setting-address')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-map-marker-alt"></i></span>
							<span class="nav-link">Pengaturan Alamat</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'setting-pin' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('setting-pin')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-lock"></i></span>
							<span class="nav-link">Pengaturan PIN</span>
						</div>
					</router-link>
					<router-link :to="{ name: 'setting-password' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('setting-password')) || userData.stockist_type== 'utama'">
						<div class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-key"></i></span>
							<span class="nav-link">Ubah Password</span>
						</div>
					</router-link>
				</li>
				<li class="item cursor-pointer" id="accordionVoucher" data-toggle="collapse" data-target="#collapseVoucher" v-if="(userData.stockist_menu && userData.stockist_menu.includes('voucher')) || (userData.stockist_menu && userData.stockist_menu.includes('voucher-promo')) || userData.stockist_type== 'utama'">
					<span class="icon"><i class="fas fa-ticket-alt"></i></span>
					<span class="nav-link">Voucher</span>
					<span class="icon pr-0 d-flex justify-content-end"><i class="fas fa-angle-down"></i></span>
				</li>
				<li class="collapse" id="collapseVoucher" data-parent="#accordionSidebar">
					<router-link :to="{ name: 'voucher' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('voucher')) || userData.stockist_type== 'utama'">
						<li class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-table"></i></span>
							<span class="nav-link">Data Klaim Voucher</span>
						</li>
					</router-link>
					<router-link :to="{ name: 'voucher-promo' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('voucher-promo'))|| userData.stockist_type== 'utama'">
						<li class="item-collapse" @click="hideNav">
							<span class="icon font-size-10"><i class="fas fa-gift"></i></span>
							<span class="nav-link">Klaim Voucher</span>
						</li>
					</router-link>
				</li>

				<router-link :to="{ name: 'tutorial' }" class="text-deco" v-if="(userData.stockist_menu && userData.stockist_menu.includes('tutorial')) || userData.stockist_type== 'utama'">
					<li class="item" @click="hideNav">
						<span class="icon"><i class="fas fa-video"></i></span>
						<span class="nav-link">E-Learning</span>
					</li>
				</router-link>
				<!-- <div v-on:click="loginSSO()" class="text-deco" v-if="userData.stockist_type== 'utama'"> -->
				<div class="text-deco" v-if="userData.stockist_type== 'utama'">
					<div class="item">
						<span class="icon"><i class="fas fa-store"></i></span>
						<span class="nav-link">Login ke Store<div style="font-size: smaller; background: blueviolet; color: white; padding: 5px 8px; border-radius: 25px;">Coming Soon</div></span>
					</div>
				</div>
				<router-link to="/auth/login" v-on:click.native="onLogout()" class="text-deco">
					<div class="item">
						<span class="icon"><i class="fas fa-sign-out-alt"></i></span>
						<span class="nav-link">Keluar</span>
					</div>
				</router-link>
			</div>
			<!-- <li class="item-end">
				<button class="col-10 btn bg-white rounded-pill pl-0 pr-0 d-flex justify-content-center">
					<div class="color-blue-donker text-capitalize font-size-10">
						<i class="fas fa-plus"></i>
						<span class="pl-3">Tambah Admin</span>
					</div>
				</button>
			</li> -->
		</ul>
	</div>
</template>

<script>
//import { createNamespacedHelpers } from 'vuex';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
import IModal from '@/components/IModal.vue';

//const { mapState, mapActions } = createNamespacedHelpers('auth');
import { mapState, mapActions } from 'vuex';

export default {
	components: {
		IModal, AlertModal
	},
	computed: {
		...mapState('auth', ['userData', 'is_have_pin']),
		...mapState('profileList', ['responSukses', 'konfirmResponse']),
	},
	data: () => {
		return {
			data : '',
			alertSideBar: '',
			redirectPin: false,
			pin_code: '',
			pin_max_length: 6,
			pin_success: false,
		}
	},
	methods: {
		...mapActions('auth', ['logout', 'getTokenSso']),
		...mapActions('profileList', ['setPin']),

		loginSSO() {
			this.getTokenSso().then(res => {
				window.open(res.url)
			}).catch(err => {
				this.alertSideBar = err.message
				this.$refs.modalAlert.modalShow()
			})
		},
		onLogout() {
			this.logout().then(() => {
				this.$router.push({ name: 'login' });
			});
		},
		removeAlert() {
			if (this.redirectPin == true) {
				this.$refs.modalAlert.modalHide()
				this.redirectPin = false
				this.$router.push('/setting-pin');
			} else {
				this.$refs.modalAlert.modalHide()
			}
		},
		hideNav() {
			if (window.matchMedia('(min-width: 1025px)').matches) {
				document.querySelector(".navbar.hide").classList.add("toggle")
				setTimeout(function(){
					document.querySelector(".navbar.hide").classList.remove("toggle")
				}, 1000)
			}
			else {
				document.querySelector(".navbar.hide").classList.remove("show")
				document.querySelector(".btn-mobile-menu").classList.remove("show")
				this.$emit('action', false)
			}
		},
		dialogPin(){
			//console.log('Sidebar.vue', this.is_have_pin)
			if (this.is_have_pin == false) {
				// this.alertSideBar = 'Anda belum memiliki PIN Mobile Counter. Silahkan melakukan pengaturan PIN pada Menu Pengaturan > Pengaturan PIN'
				// this.redirectPin = true
				this.$refs.modalSetPin.modalShow()
			}
		},
		hideModalPin(){
			this.$refs.modalSetPin.modalHide()
		},
		submitPin(){
			if (this.pin_code.length > 0 && this.pin_code.length == this.pin_max_length) {
                var params = {
                    pin_code: this.pin_code,
                    otp_code: '000000'
                }

                this.setPin(params).then(() => {
                    //console.log
                    if (this.responSukses == 200) {
                        this.pin_code = ''
                        this.pin_success = true
                    }
                })
            }
		}
	},
	mounted(){
		this.dialogPin()
	}
};
</script>

<style scoped>
</style>
